import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const instanceNameValidator = (allInstances):  ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
  let diffName = true;
    allInstances.forEach(instance => {
      if (control?.value?.toLowerCase() === instance?.name?.toLowerCase()) {
          diffName = false;
      }
    })
    return diffName ? null : {name: {value: control.value}};
  };
}